import { useEffect } from "react";
import usePagination from "./usePagination";
import { useQuery } from "@apollo/client";
import { GET_SOS_STATUSES } from "graphql/queries/sos_statuses";
import { ISosStatus, ISosStatusIndexParams } from "models/Sos";

const useSosStatuses = ({
    sos_id = undefined,
    page: externalPage,
    pageSize: externalPageSize,
    orderBy = "desc",
    startDate,
    endDate
}: ISosStatusIndexParams) => {

    const hookSosStatuses = usePagination<ISosStatus>({
        page: externalPage,
        pageSize: externalPageSize,
        sortOrder: orderBy as "desc" | "asc"
    });

    const { page, pageSize } = hookSosStatuses;
    const { data, loading } = useQuery(GET_SOS_STATUSES(sos_id, page, pageSize, orderBy as "desc" | "asc", startDate, endDate), {
        pollInterval: 1000*60, //Actualiza cada minuto
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'network-only',
    });

    useEffect(() => {
        if (loading) {
            hookSosStatuses.loadingStart();
        } else {
            hookSosStatuses.loadingEnd();
        }

        if (data) {
            // console.log("🚀 ~ useEffect ~ data:", data)
            const { its_sos_statuses: dataSosStatuses, its_sos_statuses_aggregate } = data;
            const { count: totalItems } = its_sos_statuses_aggregate.aggregate;
            hookSosStatuses.setData(dataSosStatuses);
            hookSosStatuses.setTotalItems(totalItems);
        }
    }, [data, loading]);

    return hookSosStatuses;
};

export default useSosStatuses;
